export const WORKSHOP_MANAGER_ROLE = 'workshop_manager';

// Roles that inherit the access of other roles. A Workshop Manager has full technician access.
const IMPLIED_ROLES: Record<string, string[]> = {
  [WORKSHOP_MANAGER_ROLE]: ['technician'],
};

export const expandRoles = (roles: unknown): string[] => {
  const baseRoles = Array.isArray(roles) ? roles.map((role) => String(role || '')) : [];
  const expanded = new Set(baseRoles);
  baseRoles.forEach((role) => {
    (IMPLIED_ROLES[role.toLowerCase()] || []).forEach((implied) => expanded.add(implied));
  });
  return Array.from(expanded);
};
